// 解鎖方式
export const unlockMethodConfig = {
  number: { label: '數字密碼', value: 'number' },
  qrCode: { label: 'QR Code', value: 'qrCode' },
}

// 有效狀態
export const effectiveStatusConfig = {
  notEffective: { label: '尚未生效', value: 'notEffective', tagType: 'info' },
  effective: { label: '有效', value: 'effective', tagType: 'action' },
  expired: { label: '已失效', value: 'expired', tagType: 'info' },
}

// 連線狀態
export const connectionStatusConfig = {
  online: { label: '連線正常', value: 'online', tagType: 'action' },
  offline: { label: '斷線中', value: 'offline', tagType: 'danger' },
}

// 建立來源
export const createSourceConfig = {
  admin: { label: '後台手動建立', value: 'admin' },
  order: { label: '訂單自動產生', value: 'order' },
}
